import { appEntities } from "./app";
import { appExternalAwsRdsConnectionEntities } from "./app-external-aws-rds-connection";
import { serviceDefinitionEntities } from "./app-service-definitions";
import { backupEntities } from "./backup";
import { backupRpEntities } from "./backup-retention-policy";
import { certificateEntities } from "./certificate";
import { appConfigEntities } from "./configuration";
import { containerEntities } from "./container";
import { costEntities } from "./cost";
import { dashboardEntities } from "./dashboard";
import { databaseEntities } from "./database";
import { credEntities } from "./database-credential";
import { databaseImageEntities } from "./database-images";
import { diskEntities } from "./disk";
import { diskAttachmentEntities } from "./disk-attachment";
import { edgeEntities } from "./edge";
import { endpointEntities } from "./endpoint";
import { environmentEntities } from "./environment";
import { externalAwsAccountEntities } from "./external-aws-account";
import { externalAwsResourceEntities } from "./external-aws-resource";
import { imageEntities } from "./image";
import { llmGatewayConfigurationEntities } from "./llm-gateway-configuration";
import { llmGatewayKeyEntities } from "./llm-gateway-key";
import { llmKeyEntities } from "./llm-key";
import { llmPolicyEntities } from "./llm-policy";
import { logDrainEntities } from "./log-drain";
import { manualScaleRecommendationEntities } from "./manual_scale_recommendation";
import { metricDrainEntities } from "./metric-drain";
import { opEntities } from "./operation";
import { permissionEntities } from "./permission";
import { persistentDiskEntities } from "./persistent-disk";
import { activePlanEntities, planEntities } from "./plan";
import { releaseEntities } from "./release";
import {
  customerControlEntities,
  customerControlResourceEntities,
  globalControlEntities,
  globalControlFrameworkEntities,
} from "./security-controls";
import { serviceEntities } from "./service";
import { serviceSizingPolicyEntities } from "./service-sizing-policy";
import { settingEntities } from "./setting";
import { stackEntities } from "./stack";
import { vpcPeerEntities } from "./vpc-peer";
import { vpnTunnelEntities } from "./vpn-tunnel";

export const entities = {
  ...llmGatewayConfigurationEntities,
  ...llmGatewayKeyEntities,
  ...llmKeyEntities,
  ...llmPolicyEntities,
  ...appEntities,
  ...appExternalAwsRdsConnectionEntities,
  ...certificateEntities,
  ...serviceDefinitionEntities,
  ...stackEntities,
  ...environmentEntities,
  ...endpointEntities,
  ...databaseEntities,
  ...logDrainEntities,
  ...metricDrainEntities,
  ...serviceEntities,
  ...databaseImageEntities,
  ...opEntities,
  ...planEntities,
  ...activePlanEntities,
  ...permissionEntities,
  ...releaseEntities,
  ...containerEntities,
  ...vpcPeerEntities,
  ...vpnTunnelEntities,
  ...edgeEntities,
  ...appConfigEntities,
  ...backupEntities,
  ...backupRpEntities,
  ...credEntities,
  ...imageEntities,
  ...diskEntities,
  ...persistentDiskEntities,
  ...diskAttachmentEntities,
  ...serviceSizingPolicyEntities,
  ...settingEntities,
  ...manualScaleRecommendationEntities,
  ...costEntities,
  ...dashboardEntities,
  ...externalAwsAccountEntities,
  ...externalAwsResourceEntities,
  ...globalControlEntities,
  ...globalControlFrameworkEntities,
  ...customerControlEntities,
  ...customerControlResourceEntities,
};
